import { useEffect, useRef, useState } from "react";
import { Volume2 } from "lucide-react";

export const BrandVideo = () => {
  const wrapRef = useRef(null);
  const vidRef = useRef(null);
  const [load, setLoad] = useState(false);
  const [muted, setMuted] = useState(true);

  useEffect(() => {
    const el = wrapRef.current;
    if (!el) return undefined;
    const obs = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setLoad(true);
          obs.disconnect();
        }
      },
      { rootMargin: "400px" }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (load) vidRef.current?.play().catch(() => {});
  }, [load]);

  const unmute = () => {
    const v = vidRef.current;
    if (!v) return;
    v.muted = false;
    v.volume = 1;
    v.play().catch(() => {});
    setMuted(false);
  };

  return (
    <section data-testid="brand-video-section" className="border-t border-white/10 py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-6">
        <div
          ref={wrapRef}
          className="relative aspect-video w-full overflow-hidden rounded-2xl border border-white/10 bg-black"
        >
          <video
            ref={vidRef}
            data-testid="brand-video"
            className="h-full w-full object-cover"
            src={load ? "/files/DAH_Menu.mp4" : undefined}
            poster="/files/DAH_Menu_poster.jpg"
            autoPlay
            muted
            loop
            playsInline
            controls
            preload="none"
          />
          {muted && (
            <button
              type="button"
              onClick={unmute}
              data-testid="brand-video-sound-button"
              className="absolute right-4 top-4 inline-flex items-center gap-2 rounded-full border border-white/25 bg-black/70 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.2em] text-white backdrop-blur-md transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-white hover:text-black"
            >
              <Volume2 className="h-3.5 w-3.5" /> Tap for sound
            </button>
          )}
        </div>
      </div>
    </section>
  );
};
